<template>
  <NavbarFive class="home_one" />
  <ResponsiveNavbarFive class="home_one" />
  <PageBanner pageTitle="Blog Right Sidebar" mainTitle="Blog Right Sidebar" />
  <BlogRightSidebar />
  <DownloadTheApp />
  <MainFooter />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import NavbarFive from "../components/Layouts/NavbarFive.vue";
import ResponsiveNavbarFive from "../components/Layouts/ResponsiveNavbarFive.vue";
import PageBanner from "../components/Common/PageBanner.vue";
import BlogRightSidebar from "../components/BlogRightSidebar/BlogRightSidebar.vue";
import DownloadTheApp from "../components/Common/DownloadTheApp.vue";
import MainFooter from "../components/Layouts/MainFooter.vue";

export default defineComponent({
  name: "BlogRightSidebarPage",
  components: {
    NavbarFive,
    ResponsiveNavbarFive,
    PageBanner,
    BlogRightSidebar,
    DownloadTheApp,
    MainFooter,
  },
});
</script>